import { createSmsComplianceService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const SmsComplianceService = createSmsComplianceService(authorizedHttpClient, import.meta.env.VITE_API_URL)
